<!--
  Esta es la plantilla que se usa para las páginas externas (fuera del panel), como por ejemplo, la pagina de login
-->
<template>
  <v-fade-transition hide-on-leave>
    <router-view />
  </v-fade-transition>
</template>

<script>
export default {};
</script>

<style>
</style>
